export default __webpack_public_path__ + "static/media/meetStakeholders.fbc03e9b.svg";